import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import Api from "../../Api";
import QuoteDisplay from "../../parts/quote/Display";
import DiscreetMessage from "../../parts/DiscreetMessage";
import { Client, Quote, User } from "../../types";

const LegacyQuote = () => {
  const { search } = useLocation();
  const [quote, setQuote] = useState<Quote | null>(null);
  const [client, setClient] = useState<Client | null>(null);
  const [seller, setSeller] = useState<User | null>(null);
  const [equipmentMap, setEquipmentMap] = useState<Record<
    string,
    string
  > | null>(null);

  useEffect(() => {
    Api.externalGetQuote(new URLSearchParams(search).get("hash")!).then(
      ({ quote, client, seller, equipmentMap }) => {
        setQuote(quote);
        setClient(client);
        setSeller(seller);
        setEquipmentMap(equipmentMap);
      }
    );
  }, [search]);

  if (!quote || !client || !seller || !equipmentMap)
    return <DiscreetMessage text="Carregando ..." />;

  return (
    <div>
      <QuoteDisplay
        quote={quote}
        client={client}
        seller={seller}
        equipmentMap={equipmentMap}
      />
    </div>
  );
};

export default LegacyQuote;
